import MediaItem from "../models/media-item";
import {AdsItem, AlbumInfo} from "../models/responses";
import {User} from "../types/user";
import {Reducer} from "redux";
import {MediaAlbumActions} from "../store/media-album-types";

export interface MediaAlbumState {
    media: MediaItem[]
    album_info?: AlbumInfo
    isLocked: boolean
    users: User[]
    ads: AdsItem[]
    mediaComments: { [key: number]: Comment }
}

const initialState: MediaAlbumState = {ads: [], users: [], media: [], isLocked: false, mediaComments: []}

export const mediaAlbumReducer: Reducer<MediaAlbumState, MediaAlbumActions> = (state = initialState, action) => {
    switch (action.type) {
        case "ALBUM_CHANGED":
            return {...initialState}
        case "ALBUM_INFO_RECEIVED":
            return {
                ...initialState,
                album_info: action.payload.album_info,
                media: action.payload.media,
                users: action.payload.users
            }
        case "COMMENTS_RECEIVED":
            let mediaItems = state.media.map((i) => {
                if (i.id === action.itemId) {
                    return {...i, comments: action.payload}
                } else {
                    return i
                }
            })

            return {...state, media: mediaItems}
        case "ALBUM_IS_LOCKED":
            return {...initialState, isLocked: true}
        case "ADS_INFO_RECEIVED":
            return {...state, ads: action.payload}
        default:
            return state
    }
}